var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.treedata != null)?_c('DraggableTree',{ref:"tree",attrs:{"data":_vm.treedata,"draggable":"true"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var store = ref.store;
var vm = ref.vm;
return _c('div',{staticClass:"clearfix"},[(!data.isDragPlaceHolder)?[_vm._t("default",null,{"data":data,"store":store})]:_vm._e()],2)}}],null,true)}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03781947","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic_comp/TreeWrapper.vue
// module id = null
// module chunks = 